import $ from 'jquery'

/**
 * oid로 인증서종류 추출.
 * 확인된것 외에는 기타
 */
export const getCertType = (oid) => {
  var divNm = "기타";
  var perArr = ['1.2.410.200005.1.1.1'
    , '1.2.410.200004.5.1.1.5'
    , '1.2.410.200004.5.2.1.2'
    , '1.2.410.200004.5.4.1.1'
    , '1.2.410.200012.1.1.1'
    , '1.2.410.200005.1.1.4'
    , '1.2.410.200012.1.1.101'
    , '1.2.410.200004.5.2.1.7.1'
    , '1.2.410.200004.5.4.1.101'
    , '1.2.410.200004.5.1.1.9.2'
    , '1.2.410.200004.5.2.1.7.3'
    , '1.2.410.200004.5.4.1.103'
    , '1.2.410.200012.1.1.105'
    , '1.2.410.200012.1.1.103'
    , '1.2.410.200004.5.1.1.9'
    , '1.2.410.200004.5.2.1.7.1'
    , '1.2.410.200004.5.4.1.101'
    , '1.2.410.200012.1.1.101'
    , '1.2.410.200004.5.1.1.9'
    , '1.2.410.200004.5.2.1.7.2'
    , '1.2.410.200004.5.4.1.102'
    , '1.2.410.200012.1.1.103'
    , '1.2.410.200004.5.4.1.104'
    , '1.2.410.200004.5.5.1.3.1'
    , '1.2.410.200004.5.5.1.4.1'
    , '1.2.410.200004.5.5.1.4.2'];
  var bizArr = ['1.2.410.200005.1.1.5'
    , '1.2.410.200004.5.1.1.7'
    , '1.2.410.200004.5.2.1.1'
    , '1.2.410.200004.5.4.1.2'
    , '1.2.410.200012.1.1.3'
    , '1.2.410.200005.1.1.2'
    , '1.2.410.200005.1.1.6.1'
    , '1.2.410.200004.5.1.1.12.908'
    , '1.2.410.200004.5.2.1.5001'
    , '1.2.410.200004.5.2.1.6.257'
    , '1.2.410.200005.1.1.6.8'
    , '1.2.410.200005.1.1.6.3'
    , '1.2.410.200005.1.1.6.5'
    , '1.2.410.200005.1.1.6.4'
    , '1.2.410.200005.1.1.7.1'
    , '1.2.410.200004.5.5.1.2'];

  if ($.inArray(oid, perArr) !== -1) {
    divNm = "개인";
  } else if ($.inArray(oid, bizArr) !== -1) {
    divNm = "법인";
  }

  return divNm;
}
